module.exports = __webpack_public_path__ + "img/create-bond.78c460d6.png";